// A read that failed, with its retry — the custody screens' own until the
// kit's ReadFailed lands on main (Screens, 22 Oct 2026); then this file goes.
import { StateLine } from '../../components/kit';
import { SigninQuiet } from '../../components/v2/custody/SigninLine';
import { isCustodySignin } from '../../lib/errors';

const textOf = (err: unknown): string => String((err as { message?: unknown } | null)?.message ?? err);

export function ReadFailed({ what, error, onRetry, pending = false, className = '' }: {
  /** What could not be read, as the sentence says it: "the approvals". */
  what: string;
  error: unknown;
  onRetry: () => void;
  pending?: boolean;
  className?: string;
}) {
  // The lapsed custody sign-in: said once by the section's line (CustodySigninShell), not here.
  if (isCustodySignin(error)) return <SigninQuiet error={error} className={className} />;
  return (
    <StateLine
      tone="bad"
      className={className}
      more={textOf(error)}
      action={<button type="button" className="btn-secondary min-h-[44px] text-body lg:min-h-[40px]" disabled={pending} onClick={onRetry}>{pending ? 'Reading…' : 'Try again'}</button>}
    >
      Couldn't read {what} — try again.
    </StateLine>
  );
}
